import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=3121604c&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=3121604c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121604c",
  null
  
)

export default component.exports